import { HTTP_ERROR_BAD_REQUEST, HTTP_ERROR_FORBIDDEN, HTTP_ERROR_NOT_AUTHORIZED } from '@ogsnetwork/opp-api-lib';
function errorHasKey(errorData, errorKey) {
    return typeof errorData !== 'undefined' && errorKey in errorData;
}
export function useError(props) {
    var _a;
    const { error, errorKey, length = 1, type } = props;
    if (typeof error !== 'undefined') {
        if ([HTTP_ERROR_NOT_AUTHORIZED, HTTP_ERROR_BAD_REQUEST, HTTP_ERROR_FORBIDDEN].includes((_a = error.type) !== null && _a !== void 0 ? _a : '')) {
            if (errorHasKey(error.data, errorKey)) {
                const keyErrors = error.data[errorKey];
                if (!keyErrors) {
                    return undefined;
                }
                const messages = [];
                for (const keyError of keyErrors) {
                    if (type && keyError.type !== type) {
                        continue;
                    }
                    messages.push(keyError.message);
                    if (messages.length >= length) {
                        break;
                    }
                }
                return messages;
            }
        }
    }
    return undefined;
}
